export default "__VITE_ASSET__Cff9AL7x__"